<div class="container">
    <div class="row main">
        <div class="main-login main-center col-xs-12 col-md-10 col-lg-8">
            <form class="form-horizontal" #recoverForm="ngForm">
                <div class="form-group">
                    <label for="email" class="cols-sm-2 control-label">{{ modelService.getString('recover_instructions') }}</label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa fa-envelope fa" aria-hidden="true"></i></span>
                        <input required autofocus type="email" class="form-control" name="email" id="email" [(ngModel)]="email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" placeholder="{{ modelService.getString('input_mail') }}" />
                    </div>
                </div>

                <div class="form-group">
                    <button type="button" class="btn btn-primary btn-lg btn-block login-button form-control" (click)="recoverPassword()" [disabled]="!recoverForm.form.valid || loading">{{ modelService.getString('recover_password') }}</button>
                </div>
                <div class="login-register">
                    <a routerLink="/login">{{ modelService.getString('rec_back_login') }}</a>
                </div>
            </form>
        </div>
    </div>
</div>